const MODULE_NAME = "AUTH";
const FORBIDDEN_TRIGGERED = MODULE_NAME + 'FORBIDDEN_TRIGGERED';
const FORBIDDEN_RESET = MODULE_NAME + 'FORBIDDEN_RESET';

export {
  FORBIDDEN_TRIGGERED,
  FORBIDDEN_RESET
};
